import { Navigate } from "react-router-dom";

// StatsPage 已由 AdminDashboardPage / AdminAnalyticsPage 取代，
// 保留此路由并重定向到新的仪表盘，避免旧书签失效。
export function StatsPage() {
  return <Navigate to="/admin/dashboard" replace />;
}
